/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Types of biometric authentication */
export enum BiometricType {
  Fingerprint,
  FaceRecognition,
  IrisRecognition,
  VoiceRecognition,
  Signature,
  Gait,
  Behavioral,
}

export type BiometricTypeArgs = BiometricType;

export function getBiometricTypeEncoder(): FixedSizeEncoder<BiometricTypeArgs> {
  return getEnumEncoder(BiometricType);
}

export function getBiometricTypeDecoder(): FixedSizeDecoder<BiometricType> {
  return getEnumDecoder(BiometricType);
}

export function getBiometricTypeCodec(): FixedSizeCodec<
  BiometricTypeArgs,
  BiometricType
> {
  return combineCodec(getBiometricTypeEncoder(), getBiometricTypeDecoder());
}
